const API_URL = process.env.REACT_APP_API_URL;

export const getDailyStats = async () => {
    const token = localStorage.getItem('token');
    
    return fetch(`${API_URL}/api/v1/daily-stats`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};
